import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import styled from 'styled-components';

import { useContent } from '../../content/load';

const Bar = styled.nav`
  position: sticky;
  top: 0;
  z-index: 10;
  height: ${(p) => p.theme.layout.nav}px;
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.step[6]}px;
  padding: 0 ${(p) => p.theme.layout.gutter}px;
  background: rgba(10, 10, 11, 0.86);
  backdrop-filter: saturate(140%) blur(10px);
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
`;

const Brand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${(p) => p.theme.color.text[0]};
`;

const Mark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: ${(p) => p.theme.color.accent.amber};
  color: ${(p) => p.theme.color.bg[0]};
  font-family: ${(p) => p.theme.font.mono};
  font-weight: 700;
`;

const Links = styled.div`
  display: flex;
  gap: ${(p) => p.theme.step[5]}px;
  margin-left: ${(p) => p.theme.step[5]}px;

  @media (max-width: 720px) {
    display: none;
  }
`;

const NavItem = styled(RouterNavLink)`
  font-size: ${(p) => p.theme.step[3]}px;
  color: ${(p) => p.theme.color.text[1]};
  transition: color 160ms ${(p) => p.theme.ease};

  &:hover { color: ${(p) => p.theme.color.text[0]}; }
  &.active { color: ${(p) => p.theme.color.accent.amber}; }
`;

const Spacer = styled.div`
  flex: 1;
`;

const Auth = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const Ghost = styled(Link)`
  font-size: ${(p) => p.theme.step[3]}px;
  color: ${(p) => p.theme.color.text[1]};
  &:hover { color: ${(p) => p.theme.color.text[0]}; }
`;

const Primary = styled(Link)`
  font-size: ${(p) => p.theme.step[3]}px;
  padding: 8px 14px;
  border-radius: 6px;
  background: ${(p) => p.theme.color.accent.amber};
  color: ${(p) => p.theme.color.bg[0]};
  font-weight: 600;
`;

export function Nav() {
  const { site } = useContent();
  return (
    <Bar>
      <Brand to="/">
        <Mark>{site.brand.mark}</Mark>
        <span>{site.brand.name}</span>
      </Brand>
      <Links>
        {site.nav.map((l) => (
          <NavItem key={l.href} to={l.href}>
            {l.label}
          </NavItem>
        ))}
      </Links>
      <Spacer />
      <Auth>
        <Ghost to="/login">Sign in</Ghost>
        <Primary to="/signup">Get started</Primary>
      </Auth>
    </Bar>
  );
}
